module.exports = __webpack_public_path__ + "img/17a002-04.6127d362.jpg";